export const CELL_PADDING_LEFT = 9;
export const HEADER_PADDING_RIGHT = 4;
export const ICON_WIDTH = 12;
export const ICON_PADDING = 7;
export const BUTTON_ICON_WIDTH = ICON_WIDTH + (ICON_PADDING + 1) * 2; // 1 is border width
export const REMOVE_TICK_LIMIT = 80; // an item width equal to or less than this, will hide the select tick
export const SCROLL_BAR_WIDTH = 10; // TODO: ignore this - instead set the styling only show on hover...
export const ITEM_MAX_WIDTH = 150;
export const ITEM_MIN_WIDTH = 56;
export const CHECKBOX_WIDTH = 20;
export const frequencyTextNone = '-';
export const barPadPx = 4;
export const barBorderWidthPx = 1;
export const barWithCheckboxLeftPadPx = 29;
export const GRID_ROW_HEIGHT = 32;
export const LIST_ROW_HEIGHT = 29;
export const DENSE_ROW_HEIGHT = 20; // same for both list and grid in dense mode
export const GRID_ITEM_PADDING = 4;
